// extracted by mini-css-extract-plugin
module.exports = {"paragraph":"rich-text_paragraph__QM1OM","root":"rich-text_root__5wmZd"};